<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Config
	import { devices_config } from '@devices/index';
	//Design system components
	import { Select, Text } from '@Shelly/shelly-design-system';
	//Types
	import type { PeripheralInputSettings } from 'src/types/Peripherals';
	import type { Device } from 'src/types/Device';

	let className = '';
	export { className as class };

	export let settings: PeripheralInputSettings,
		device: Device,
		icon: string = '';

	const deviceDefaults = devices_config?.[device?.type]?.addons_options?.measurement_ranges;
	const options = deviceDefaults || [
		{
			title: '0-15 VDC',
			value: 0,
		},
		{
			title: '0-30 VDC',
			value: 1,
		},
	];
</script>

<div class={className}>
	<Text styleType="body-small" class="mb-s">
		{$format('subtitle_input_counter_measurement_range', {
			default: 'The range which the device is measuring.',
		})}
	</Text>
	<Select
		size="m"
		width="full"
		id="select-measurement-range"
		aria-label={$format('label_select_measurement_range', {
			default: 'Select measurement range',
		})}
		{icon}
		{options}
		value={options.find((i) => i.value == settings.range) || options[0]}
		on:change={(e) => (settings.range = e.detail['value'])}
	/>
</div>
